// Copyright (c) Proto Labs, Inc. All Rights Reserved.
import AsyncLock from 'async-lock';
import { TokenManagerEventPublisher } from './TokenManagerEventPublisher';
import { TokenManagerFetchInterceptor } from './TokenManagerFetchInterceptor';
import { TokenManagerImpl } from './TokenManagerImpl';
import { TokenManagerLogger } from './TokenManagerLogger';
import { TokenManagerSettings } from './TokenManagerSettings';
import { TokenManagerState } from './TokenManagerState';
import { UrlUtility } from './UrlUtility';
import { UserManagerProxy } from './UserManagerProxy';
import { TokenManagerTimeoutMonitor } from './TokenManagerTimeoutMonitor';
export class TokenManagerFactory {
    static getTokenManager() {
        return window.tokenManager;
    }
    // Create and attach TokenManager to global window object
    static getOrCreateTokenManager(config) {
        if (window.tokenManager) {
            return window.tokenManager;
        }
        const logger = new TokenManagerLogger(config.logLevel);
        logger.debug(`TokenManagerFactory: logging level is ${config.logLevel}.`);
        const lock = new AsyncLock({ timeout: 30000 });
        const settings = new TokenManagerSettings(config, logger, new UrlUtility());
        const state = new TokenManagerState(settings.clientId, logger, sessionStorage);
        const eventPublisher = new TokenManagerEventPublisher(logger);
        const userManager = new UserManagerProxy(settings, logger);
        const timeoutMonitor = new TokenManagerTimeoutMonitor(logger, settings, state, userManager);
        const tokenManagerImpl = new TokenManagerImpl(settings, logger, lock, state, eventPublisher, userManager, timeoutMonitor);
        window.tokenManager = tokenManagerImpl;
        window.tokenManagerFetchInterceptor = new TokenManagerFetchInterceptor(tokenManagerImpl, logger, new UrlUtility(), []);
        return window.tokenManager;
    }
}
//# sourceMappingURL=TokenManagerFactory.js.map